import React, { FC } from 'react';
import { getBackgroundColor } from './company-suggestion.utils';
import { CompanySuggestionEnum } from '~/src/components/common-components/company-suggestion/company-suggestion.enum';
import type { CompanySuggestionProps } from './company-suggestion.types';
import * as Styled from './company-suggestion.styles';

/**
 * Used in Module Federation
 */
const CompanySuggestion: FC<CompanySuggestionProps> = (props) => {
    return (
        <Styled.CompanySuggestion>
            <Styled.NameLine>
                <Styled.Name>
                    {props?.opf?.shortName} {props?.fullName || props?.name?.fullName}
                </Styled.Name>
                {props.stateStatus && <Styled.Status backgroundColor={getBackgroundColor(props.stateStatus)}>
                    {CompanySuggestionEnum[props.stateStatus]}
                </Styled.Status>}
            </Styled.NameLine>
            <Styled.MainLine>
                <Styled.Label>{props?.management?.post || 'Генеральный директор'}</Styled.Label>
                <Styled.CompanyHeadName>{props?.management?.name || props?.fullName}</Styled.CompanyHeadName>
                <Styled.Address>{props?.addressFullName || props?.address?.fullName}</Styled.Address>
            </Styled.MainLine>
            <Styled.CodesLine>
                <Styled.CodeWrap>
                    {props.inn && <><Styled.Label>ИНН</Styled.Label>
                        {props.inn}
                    </>}
                </Styled.CodeWrap>
                <Styled.CodeWrap>
                    {props.ogrn && <><Styled.Label>ОГРН</Styled.Label>
                        {props.ogrn}
                    </>}
                </Styled.CodeWrap>
                <Styled.CodeWrap>
                    {props.kpp && <><Styled.Label>КПП</Styled.Label>
                        {props.kpp}
                    </>}
                </Styled.CodeWrap>
            </Styled.CodesLine>
        </Styled.CompanySuggestion>
    );
};

export default CompanySuggestion;
